import React, { useState, useEffect, useRef } from "react";

import { trackPromise } from "react-promise-tracker";
import pastaSvg from "../../assets/icons/pastaDash.svg";
import menuCopiar from "../../assets/iconsMenu/menuCopiar.svg";
import iconDownloadWhite from "../../assets/icons/iconDownloadWhite.svg";
import Header from "../../components/Header";
import { saveAs } from "file-saver";
import {
  detalhesDashboardAdministrador,
  exportarMaisBaixadosUsuarioComum,
  exportarMaisBaixadosAdministrador,
  exportarArquivos,
  detalhesDashboardUsuarioComum,
} from "../../services/http/dashboardService";
import services from "../../services";
import { detalhesUsuario } from "../../services/http/usuariosService";
import { Avatar, Checkbox, Button, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./styles.scss";

const Dashboard = () => {
  const { IdUser, login, IsAdmin } = services.storage.getUser();

  const [usuario, setUsuario] = useState({});
  const [dashboard, setDashboard] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingArquivos, setLoadingArquivos] = useState(false);
  const [loadingMaisBaixados, setLoadingMaisBaixados] = useState(false);

  const antIcon = (
    <LoadingOutlined
      style={{ display: "flex", justifyContent: "center", fontSize: 50 }}
      spin
    />
  );

  const showIniciais = (nome) => {
    let nomecompleto = nome.replace(".", " "); // Remove os de,da, dos,das.
    var iniciais = nomecompleto.match(/\b(\w)/gi); // Iniciais de cada parte do nome.
    var sobrenomes = iniciais.splice(0, iniciais.length).join("").toUpperCase(); // Iniciais
    return sobrenomes;
  };

  const buscarDetalhes = () => {
    trackPromise(
      detalhesUsuario(IdUser)
        .then((res) => {
          if (!res.fail && res.data) {
            setUsuario(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const gerarExelMaisBaixados = () => {
    if (IsAdmin == "True") {
      exelMaisBaixadosUsuarioAdm();
    } else {
      exelMaisBaixadosUsuarioComum();
    }
  };

  const exportarArquivosAdmin = () => {
    setLoadingArquivos(true);
    trackPromise(
      exportarArquivos().then((res) => {
        if (res.data) {
          saveAs(res.data, "arquivos.xlsx");
          setLoadingArquivos(false);
        } else {
          console.error("Não foi possível gerar exel");
          setLoadingArquivos(false);
        }
      })
    ).catch((error) => {
      setLoadingArquivos(false);
      console.error("Não foi possível gerar exel");
    });
  };

  const exelMaisBaixadosUsuarioAdm = () => {
    setLoadingMaisBaixados(true);
    trackPromise(
      exportarMaisBaixadosAdministrador().then((res) => {
        if (res.data) {
          setLoadingMaisBaixados(false);
          saveAs(res.data, "mais-baixados.xlsx");
        } else {
          setLoadingMaisBaixados(false);
          console.error("Não foi possível gerar exel");
        }
      })
    ).catch((error) => {
      setLoadingMaisBaixados(false);
      console.error("Não foi possível gerar exel");
    });
  };

  const exelMaisBaixadosUsuarioComum = () => {
    setLoadingMaisBaixados(true);
    trackPromise(
      exportarMaisBaixadosUsuarioComum().then((res) => {
        if (res.data) {
          saveAs(res.data, "mais-baixados.xlsx");
          setLoadingMaisBaixados(false);
        } else {
          console.error("Não foi possível gerar exel");
          setLoadingMaisBaixados(false);
        }
      })
    ).catch((error) => {
      setLoadingMaisBaixados(false);
      console.error("Não foi possível gerar exel");
    });
  };

  const detalhesDashboardAdmin = () => {
    setLoading(true);
    trackPromise(
      detalhesDashboardAdministrador()
        .then((res) => {
          if (!res.fail && res.data) {
            setDashboard(res.data);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        })
    );
  };

  const detalhesDashboardComumUser = () => {
    setLoading(true);
    trackPromise(
      detalhesDashboardUsuarioComum()
        .then((res) => {
          if (!res.fail && res.data) {
            setDashboard(res.data);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        })
    );
  };

  useEffect(() => {
    buscarDetalhes();
  }, []);

  useEffect(() => {
    if (IsAdmin == "True") {
      return detalhesDashboardAdmin();
    }
    detalhesDashboardComumUser();
  }, []);

  return (
    <div>
      <Header style={{ marginBottom: "2rem" }} mostrarPesquisar={false} />
      {loading ? (
        <div className="load-spiner">
          {" "}
          <Spin indicator={antIcon} />
        </div>
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="avatar-dash mt-1">
                <Avatar size={120} className="avatar-dashboard">
                  <strong>{showIniciais(login)}</strong>
                </Avatar>

                <span className="name-user mt-4">{login}</span>
                <span className="name-user-admin mt-3">
                  <b>{IsAdmin == "True" ? "Administrador" : ""}</b>
                </span>
              </div>

              <div className="mt-4">
                <span className="" style={{ color: "#0042DD" }}>
                  PERMISSÕES DE VISUALIZAÇÃO
                </span>
                {usuario?.permissoes?.map((item, index) => {
                  return (
                    <div key={index} className="dashboard-permissoes mt-3">
                      <Checkbox disabled={true} defaultChecked={true}>
                        {item.permissao}
                      </Checkbox>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="col-md-9 col-sm-6 col-lg-9">
              <div
                style={{
                  padding: "0px 0px 15px 0px",
                  borderBottom: "solid 1px #898989",
                }}
                className="mb-5"
              >
                <span className="titulo-perm">Dashboard</span>
              </div>
              {IsAdmin == "True" && (
                <div className="first-card mb-4 ">
                  <div className="armazenamento-label">Armazenamento</div>
                  <div class="progress">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      aria-valuenow="75"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{
                        width: `${dashboard?.porcentagemArmazenamento}%`,
                        height: "20px",
                      }}
                    ></div>
                  </div>
                  <div className="espaco-label" style={{ fontWeight: "500" }}>
                    <span style={{ color: "#0042DD" }}>
                      {dashboard?.armazenamentoMidiaCenter}
                    </span>{" "}
                    {dashboard?.armazenamentoBlob && "de"}{" "}
                    {dashboard?.armazenamentoBlob}{" "}
                    {dashboard?.armazenamentoBlob && "GB"}
                  </div>
                </div>
              )}
              {IsAdmin == "True" && (
                <div className="row second-card">
                  <div className="col-md-5 col-sm-5 col-lg-5 right-side ">
                    <div className="utilizacao-label">Utilização</div>
                    <div className="row">
                      <div className="col-md-6 col-sm-6 col-lg-6 pl-1">
                        <span className="letter-utilizacao">
                          {dashboard?.utilizacao?.qtdPastas}
                        </span>
                        <div className="utilizacao-label-fo ml-2">
                          <img
                            src={pastaSvg}
                            alt="pasta"
                            style={{
                              width: "20px",
                              height: "20px",
                              marginRight: "5px",
                            
                            }}
                          />
                          Pastas
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6 col-lg-6">
                        <span className="letter-utilizacao">
                          {dashboard?.utilizacao?.qtdArquivos}
                        </span>
                        <div className="utilizacao-label-fo ml-2">
                          <img
                            src={menuCopiar}
                            alt="pasta"
                            style={{
                              width: "20px",
                              height: "20px",
                              marginRight: "5px",
                            }}
                          />
                          Arquivos
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 col-sm-7 col-lg-7 left-side ">
                    <div className="row second-card-download">
                      <Button
                        className="button-download mt-3"
                        loading={loadingArquivos}
                        onClick={() => exportarArquivosAdmin()}
                        type="primary"
                        shape="round"
                        icon={<img src={iconDownloadWhite} />}
                        size="small"
                      >
                        <span style={{ fontSize: "12px" }}>Fazer download</span>
                      </Button>
                    </div>
                    <div className="row">
                      <div className="col-md-3 col-sm-3 col-lg-3 margin-top-percent">
                        <span className="letter-utilizacao-percent">
                          {dashboard?.utilizacao?.porcentagemFotos}
                        </span>
                        <div className="utilizacao-label-bottom ml-2">
                          Fotos
                        </div>
                        <div className="utilizacao-footer-label ml-2">
                          {dashboard?.utilizacao?.qtdFotos} arquivos
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-3 col-lg-3 margin-top-percent">
                        <span className="letter-utilizacao-percent">
                          {dashboard?.utilizacao?.porcentagemDocumentos}
                        </span>
                        <div className="utilizacao-label-bottom ml-2">
                          Documentos
                        </div>
                        <div className="utilizacao-footer-label ml-2">
                          {dashboard?.utilizacao?.qtdDocumentos} arquivos
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-3 col-lg-3 margin-top-percent">
                        <span className="letter-utilizacao-percent">
                          {dashboard?.utilizacao?.porcentagemVetores}
                        </span>
                        <div className="utilizacao-label-bottom ml-2">
                          Vetores
                        </div>
                        <div className="utilizacao-footer-label ml-2">
                          {dashboard?.utilizacao?.qtdVetores} arquivos
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-3 col-lg-3 margin-top-percent">
                        <span className="letter-utilizacao-percent">
                          {dashboard?.utilizacao?.porcentagemVideos}
                        </span>
                        <div className="utilizacao-label-bottom ml-2">
                          Vídeos
                        </div>
                        <div className="utilizacao-footer-label ml-2">
                          {dashboard?.utilizacao?.qtdVideos} arquivos
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="row d-flex justify-content-md-between justify-content-center" >
                <div className="col-md-6 col-sm-12 col-lg-6 third-card mt-4">
                  <div className="mais-card">Mais vistos</div>
                  {dashboard?.maisVistos?.length > 0 &&
                    dashboard?.maisVistos.map((element) => (
                      <div className="row letter-utilizacao-percent mais-card-label-left">
                        {element?.qtdVisualizacao}{" "}
                        <span className="label-card-mais ml-4">
                          {element?.nomeArquivo}
                        </span>
                      </div>
                    ))}
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6 third-card mt-4">
                  <div className="mais-card-donwload">
                    {" "}
                    <span style={{ marginTop: "30px" }}>
                      Mais baixados
                    </span>{" "}
                    <Button
                      onClick={() => gerarExelMaisBaixados()}
                      loading={loadingMaisBaixados}
                      className="button-download"
                      type="primary"
                      shape="round"
                      icon={<img src={iconDownloadWhite} />}
                      size="small"
                    >
                      <span style={{ fontSize: "12px" }}>Fazer download</span>
                    </Button>
                  </div>
                  {dashboard?.maisBaixados?.length > 0 &&
                    dashboard?.maisBaixados.map((element) => (
                      <div className="row letter-utilizacao-percent mais-card-label-left">
                        {element?.qtdDownloand}{" "}
                        <span className="label-card-mais ml-4">
                          {element?.nomeArquivo}
                        </span>
                      </div>
                    ))}
                </div>
              </div>

              <div className="row teste">
                <div
                  className={
                    IsAdmin.toLocaleLowerCase() == "True"
                      ? "col-md-4 compartilhamento-card"
                      : ""
                  }
                >
                  {IsAdmin.toLocaleLowerCase() == "True" && (
                    <div>
                      <div className="lixeira-label">Lixeira</div>
                      <div
                        style={{ marginTop: "-50px" }}
                        className="d-flex justify-content-center"
                      >
                        <span className="letter-lixeira">
                          {dashboard?.lixeira}
                        </span>
                      </div>
                      <div
                        style={{ textAlign: "center" }}
                        className="utilizacao-label-bottom mt-1"
                      >
                        Arquivos
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className={
                    IsAdmin.toLocaleLowerCase() == "True"
                      ? "col-md-7 col-sm-12 col-lg-12 offset-md-1 compartilhamento-card"
                      : "col-md-12 col-sm-12 col-lg-12 compartilhamento-card"
                  }
                >
                  <div className="lixeira-label">Compartilhamento</div>
                  <div className="row">
                    <div className="col-md-6 teste1">
                      <div
                        style={{ marginTop: "-50px" }}
                        className="d-flex justify-content-center"
                      >
                        <span className="letter-lixeira">
                          {dashboard?.compartilhamento?.linksPublicos}
                        </span>
                      </div>
                      <div
                        style={{ textAlign: "center" }}
                        className="utilizacao-label-bottom mt-1"
                      >
                        Links públicos
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        style={{ marginTop: "-50px" }}
                        className="d-flex justify-content-center"
                      >
                        <span className="letter-lixeira">
                          {dashboard?.compartilhamento?.pastasCompartilhadas}
                        </span>
                      </div>
                      <div
                        style={{ textAlign: "center" }}
                        className="utilizacao-label-bottom mt-1"
                      >
                        Pastas compartilhadas
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
